import { load } from '#sources/AccountLocalStorage';

import { SHOW_EMPTY_REPOSITORIES } from './constants';

export const getShowEmptyRepositoriesFromCache = () => load().get(SHOW_EMPTY_REPOSITORIES);
